module.exports = __webpack_public_path__ + "static/media/black_white_geometric.87e1295f.jpg";